module.exports = __webpack_public_path__ + "media/stylesheets/images/main/sample324x60-8cea23077834786934e427d8c5d3c7cd.jpeg";